// Import Packages
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";


// Import Material UI
import { Button, Dialog, TextField } from "@material-ui/core/";
import { Autocomplete } from "@material-ui/lab";
import { makeStyles } from '@material-ui/core/styles';

// Import Icons
import Close from "@material-ui/icons/Close";

// Import Css
import './SelectAction.css';

const useStyles = makeStyles({
    option: {
        '& > span': {
            marginRight: 10,
            fontSize: 12,
        },
        fontSize: 13,
        fontWeight: 600,
        color: '#46474E',
    }
});
const SelectAction = ({ actions, defaultItem, close, save }) => {
    const [selectableActions, setSelectableActions] = useState([]);
    const [selectedParentAction, setSelectedParentAction] = useState({});
    const { t } = useTranslation();
    const classes = useStyles();

    const label = 'CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.SCOPE.';

    useEffect(() => {
        const init = async () => {
            let newItems = [];

            await getGroupableActions(actions, newItems);
            setSelectableActions(newItems);
            if (defaultItem && defaultItem.children) {
                const name = t(`CONTENT.LIBRARY.${defaultItem.library_name}.ACTION.${defaultItem.actionName}`)
                setSelectedParentAction({
                    name,
                    item_id: defaultItem.item_id,
                    image: defaultItem.image
                });
            }
        }
        init();

    }, [])

    const getGroupableActions = (items, newItems) => {
        new Promise(async (resolve) => {
            for (let item of items) {
                if (item.type === 'groupable' || item.children) {
                    if (item.item_id) {
                        const name = t(`CONTENT.LIBRARY.${item.library_name}.ACTION.${item.action_name}`)
                        newItems.push({
                            name,
                            item_id: item.item_id,
                            image: item.image
                        });
                    }
                    if (item.children) {
                        await getGroupableActions(item.children, newItems);
                    }

                }
            }
            resolve(true);
        })
    }

    return (
        <Dialog
            id="edit-action"
            open={true}
            PaperProps={{
                style: {
                    display: "flex",
                    marginTop: "5%",
                    position: "relative",
                    gap: "2%",
                    background: "#FFFFFF",
                    height: "70%",
                    width: "40%",
                    borderRadius: "10px",
                    maxWidth: "none",
                    boxShadow: "none",
                    width: "33%",
                    height: "38%",
                    padding: "1.8% 2.5%",
                },
            }}>
            <Close className="close-edit-button" onClick={close} />
            <h2 className="check-and-add-title">{t(label + "ADD-ACTION")}</h2>
            <p className="check-and-add-description">{t(label + "ADD-ACTION-DESCRIPTION")}</p>
            {/* <hr style={{ width: "100%", marginLeft: "0", color: "#EBEBEB", backgroundColor: "#EBEBEB", height: "0.5px" }} /> */}
            <div className="check-and-add-outline-div"></div>
            <div className="check-and-add-inline-div">
                <Autocomplete
                    style={{
                        backgroundColor: "#fff",
                        height: "40px",
                        fontSize: "12px",
                        width: "90%"
                    }}
                    onChange={(event, value, reason) => setSelectedParentAction(value)}
                    value={selectedParentAction}
                    id="demo-simple-select-outlined"
                    size="small"
                    options={selectableActions}
                    getOptionLabel={(option) => option.name}
                    renderOption={(option) => (
                        <>
                            <img
                                loading="lazy"
                                width="20"
                                src={option.image}
                                alt=""
                                style={{ marginRight: '10px' }}
                            />
                            {option.name}
                        </>
                    )}
                    renderInput={(params) => (
                        <>
                            {
                                selectedParentAction && selectedParentAction.image &&
                                <img className='input-action-icon' src={selectedParentAction.image} />
                            }
                            <TextField
                                {...params}
                                className="select-action-input"
                                placeholder="No Action Selected"
                                variant="outlined"
                                classes={{
                                    root: classes.resize
                                }}
                                inputProps={{
                                    ...params.inputProps,
                                    "aria-autocomplete": 'new-password',
                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                    style: {
                                        marginLeft: '36px',
                                        fontSize: 12,
                                        fontWeight: 600,
                                        color: '#46474E'
                                    }
                                }}
                            />
                        </>
                    )}
                // renderInput={(params) => <TextField {...params} variant="outlined" />}
                />
            </div>
            <Button className="check-and-add-button" onClick={() => save(selectedParentAction?.item_id)}>{t(label + "ADD-SELECTION-BUTTON")}</Button>
        </Dialog>
    )

}




export default SelectAction;